import { createReducer } from '@reduxjs/toolkit';

import pathMyProfile from '../../thunks/profile/patchProfile';

const initialState = {
  loading: false,
  error: null
};

const pathProfileReducer = createReducer(initialState, {
  [pathMyProfile.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [pathMyProfile.fulfilled]: (state) => ({
    ...state,
    loading: false,
  }),
  [pathMyProfile.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload
  }),
});

export default pathProfileReducer;
